import { render } from "./AccountsListItem.vue?vue&type=template&id=2bcda4de"
import script from "./AccountsListItem.vue?vue&type=script&lang=js"
export * from "./AccountsListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__